const SITE_URL = "https://www.motanamy.com";

function normalizePath(path = "/") {
  if (!path || path === "") return "/";
  return path.startsWith("/") ? path : `/${path}`;
}

export function buildCanonicalUrl(path = "/") {
  return `${SITE_URL}${normalizePath(path)}`;
}

export function buildSeoMeta({
  title,
  description,
  path = "/",
  image,
  type = "website",
}) {
  const url = buildCanonicalUrl(path);

  const meta = [
    { name: "description", content: description, hid: "description" },
    { property: "og:title", content: title, hid: "og:title" },
    { property: "og:description", content: description, hid: "og:description" },
    { property: "og:url", content: url, hid: "og:url" },
    { property: "og:type", content: type, hid: "og:type" },
    { name: "twitter:card", content: "summary_large_image", hid: "twitter:card" },
    { name: "twitter:title", content: title, hid: "twitter:title" },
    { name: "twitter:description", content: description, hid: "twitter:description" },
  ];

  if (image) {
    meta.push({ property: "og:image", content: image, hid: "og:image" });
    meta.push({ name: "twitter:image", content: image, hid: "twitter:image" });
  }

  return meta;
}

export function buildArticleSchema({
  title,
  description,
  path,
  image,
  datePublished,
  dateModified,
  inLanguage,
}) {
  return {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "headline": title,
    "description": description,
    "url": buildCanonicalUrl(path),
    "image": image ? [image] : undefined,
    "datePublished": datePublished,
    "dateModified": dateModified || datePublished,
    "inLanguage": inLanguage,
    "publisher": {
      "@type": "Organization",
      "name": "Motanamy",
      "url": SITE_URL,
      "logo": {
        "@type": "ImageObject",
        "url": `${SITE_URL}/favicons/android-chrome-512x512.png`,
      },
    },
  };
}

export function buildSoftwareSchema({
  name,
  description,
  path,
  image,
  inLanguage,
  applicationCategory = "BusinessApplication",
  operatingSystem = "Windows, macOS, Linux",
}) {
  return {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": name,
    "description": description,
    "url": buildCanonicalUrl(path),
    "image": image,
    "applicationCategory": applicationCategory,
    "operatingSystem": operatingSystem,
    "inLanguage": inLanguage,
    "author": {
      "@type": "Organization",
      "name": "Motanamy",
      "url": SITE_URL,
    },
  };
}

export function buildStructuredDataScripts(schemas = []) {
  return schemas
    .filter(Boolean)
    .map((schema, index) => ({
      hid: `schema-${index}`,
      type: "application/ld+json",
      innerHTML: JSON.stringify(schema),
    }));
}
